// Internal/back-office route prefixes that should never be tracked
// by analytics (no visitor sessions, no page views, no clicks, no GA, no geolocation).
// Keep this list in sync with admin/app shell modules.
const INTERNAL_PREFIXES = [
  "/admin",
  "/contabilidade",
  "/accounting",
  "/armazem",
  "/warehouse",
  "/comercial",
  "/commercial",
  "/crm",
  "/assistencia-tecnica",
  "/technical-service",
  "/burocracia",
  "/bureaucracy",
  "/aprovisionamento",
  "/procurement",
  "/ia",
  "/catalogo",
  "/app",
  "/hexa",
];

export function isInternalRoute(pathname: string | undefined | null): boolean {
  if (!pathname) return false;
  return INTERNAL_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}
